import { useRef } from 'react'

interface Params {
  callback: any
  delay?: number
}

export function useDebounce({ callback, delay = 500 }: Params) {
  const timeOutRef = useRef<NodeJS.Timeout | null>(null)

  function debounceFunction(...params: any[]) {
    if (timeOutRef.current) clearTimeout(timeOutRef.current)

    timeOutRef.current = setTimeout(() => {
      callback(...params)
    }, delay)
  }

  return debounceFunction
}
